import {useState, useRef} from 'react';
import style from './catalogItem.module.scss';
import Checkbox from "../../../components/checkbox/checkbox";
import ReactDOM from "react-dom";
import {useSortable} from "@dnd-kit/sortable";
import { GripVertical } from 'lucide-react';
import { CSS } from '@dnd-kit/utilities';

const ActionsMenu = ({ coords, onClose, requestDelete, openCreatePopup, parentId, catalog}) => {
    if (!coords) return null;
    return ReactDOM.createPortal(
        <div style={{
            top: `${coords.bottom + window.scrollY - 20}px`, // учитываем прокрутку
            left: `${coords.left + window.scrollX - 180}px`
        }}
             className={style.actionsList}
             onClick={(e) => e.stopPropagation()}
             onMouseLeave={()=> {
                 onClose()
             }}
        >
            <button className={style.actionsItem} onClick={() => {
                requestDelete(catalog);
                onClose();
            }}>Удалить</button>
            <button className={style.actionsItem}
                    onClick={() => openCreatePopup({visible: true, categoryId: parentId, data: {...catalog}})}
            >
                Редактировать</button>
            {parentId === -1 && <button className={style.actionsItem}
                     onClick={() => openCreatePopup({visible: true, categoryId: catalog?.id, data: {}})}>Новый подкаталог</button>}
        </div>,
        document.body
    );
};

export default function CatalogItem({ catalog, setParentId, update, requestDelete, openCreatePopup, parentId}) {
    const [actionsIsActive, setActionsIsActive] = useState(false);
    const [coords, setCoords] = useState(null);
    const btnRef = useRef(null);
    const isActive = !((catalog?.subdirectories?.length === 1 && catalog?.subdirectories[0]?.name === catalog?.name) || catalog?.subdirectories === undefined || catalog?.subdirectories?.length === 0)
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({id: catalog.id});


    const handleClick = (e) => {
        e.stopPropagation();
        const rect = btnRef.current.getBoundingClientRect();
        setCoords(rect);
        setActionsIsActive(true);
    };

    return (
        <div
            {...attributes}
            className={(isDragging) ? [style.block, style.blockIsDrug].join(" ") : style.block}
            style={isActive ? { cursor: "pointer", transform: CSS.Transform.toString(transform),
                transition, } : { cursor: "default", transform: CSS.Transform.toString(transform),
                transition }}
            ref={setNodeRef}
            onClick={() => {
                if (isActive) {
                    setParentId(catalog.id);
                }
            }}
        >
              <span
                  ref={setActivatorNodeRef}
                  {...listeners}
                  style={{
                      cursor: 'grab',
                      display: 'flex',
                      alignItems: 'center',
                  }}
              >
                <GripVertical size={18} />
              </span>
            <div style={isActive ? { color: "#2e50ff" } : { color: "#222" }}>{catalog.name}</div>
            <Checkbox visible={catalog?.visible} update={update} id={catalog.id} />
            <div>{catalog?.subdirectories?.length || 0}</div>

            <div className={style.actions}>
                <button
                    ref={btnRef}
                    className={style.actionsBtn}
                    onClick={handleClick}
                >
                    <svg width="5" height="21" viewBox="0 0 5 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2.5" cy="2.5" r="2.5" fill="#D9D9D9" />
                        <circle cx="2.5" cy="10.5" r="2.5" fill="#D9D9D9" />
                        <circle cx="2.5" cy="18.5" r="2.5" fill="#D9D9D9" />
                    </svg>
                </button>
            </div>

            {actionsIsActive && (
                <ActionsMenu
                    coords={coords}
                    onClose={() => setActionsIsActive(false)}
                    requestDelete={requestDelete}
                    openCreatePopup={openCreatePopup}
                    parentId={parentId}
                    catalog = {catalog}
                />
            )}
        </div>
    );
}